import { isAutomatedWizard } from "app/components/appwizard/component-wizards/wizards/source/database-reader/app-services";
import {
    ValidationListElement,
    ValidationListStatus
} from "src/modules/wizards/common/validation-list/validation-list";
import {
    hasPrivilegeCheck,
    hasAutomatedCDCPermissionCheck,
    validateConnectionStep,
    fetchSchemasStep,
    checkCDCPermissionsStep,
    privilegeCheckStep
} from "./validation-steps-helpers";
import type { GenerateValidationListProps } from "./validation-steps.types";

export const generateValidationList = (props: GenerateValidationListProps): ValidationListElement[] => {
    const isCDC = props.isCDC ?? false;
    const type = props.type;

    const supportDownStreamCapture =
        props?.model?.connectionParams?.get?.("supportDownStreamCapture") ?? props.model?.supportDownStreamCapture ?? "";

    let validationArray: ValidationListElement[] = [
        {
            status: ValidationListStatus.Todo,
            text: "Trying to reach your Database",
            method: () => validateConnectionStep(props)
        }
    ];
    if (type === "OJET" && supportDownStreamCapture) {
        validationArray = [
            {
                status: ValidationListStatus.Todo,
                text: "Trying to reach your Downstream Database",
                method: () => validateConnectionStep(props)
            },
            {
                status: ValidationListStatus.Todo,
                text: "Trying to reach your Primary Database",
                method: () => validateConnectionStep(props, true)
            }
        ];
    }

    validationArray.push({
        status: ValidationListStatus.Todo,
        text: "Fetching Metadata about your Database",
        method: () => fetchSchemasStep(props)
    });

    if (isCDC || (props.isAutomatedAppFlow ?? isAutomatedWizard())) {
        if (hasAutomatedCDCPermissionCheck(type)) {
            validationArray.push({
                status: ValidationListStatus.Todo,
                text: "Validating CDC Permissions",
                method: () => checkCDCPermissionsStep(props)
            });
        }

        if (hasPrivilegeCheck(type)) {
            validationArray.push({
                status: ValidationListStatus.Todo,
                text: "Validating Permissions",
                method: () => privilegeCheckStep(props)
            });
        }
    }

    return validationArray;
};
